import React from 'react';

import '../common/styles/Loader.css'

// ============ all button loader ==============

const LoaderButton = () => {
    return (
        <div className="mb-1">
            <div class="spinner-4 mx-auto"></div>
        </div> 
   )
}

export default LoaderButton
